import { selector } from 'recoil';

import { Database } from '~/types/database.types';

import { supabase } from '../utils/supabaseClient';
import { partnerPicker } from './partnerPicker';

export const factoriesQuery = selector({
  key: 'FactoriesList',
  get: async ({ get }) => {
    const partner = get(partnerPicker);
    if (!partner) return [];

    const response = await supabase
      .from('factories')
      // factory_id is needed by anything that talks to the backend — the hub
      // identifies a factory by name, every API route by UUID.
      .select('factory_id, partner_name, factory_name, factory_timezone')
      .eq('partner_name', partner.partner_name);
    return response.data as Database['public']['Tables']['factories']['Row'][];
  },
});
